module.exports = __webpack_public_path__ + "static/media/julesMapVuittonStyle.35de3033.png";